(function () {
  'use strict';

  const {
    iman,
    subEvents,
    PUB_SUB_EVENTS,
    ProductCountdown,
    ProductForms,
    ProductMediaCarousel,
    ProductPairsCarousel,
    ProductReviewsCarousel,
    QuantityInput,
    Sharer,
    SizeChart,
    VariantSelect,
    StickyAddtoCart,
    Accordion,
    Lightbox,
  } = window.Universe;

  class SingleProduct {
    constructor(mainContainer) {
      this.openPickupModal = (event) => {
        if (this.DOM.pickupModal && !this.pickupModalIsOpen) {
          this.pickupTriggerElement = (event && event.currentTarget) || this.pickupTrigger;

          this.DOM.pickupModal.classList.add('is-active');
          this.DOM.pickupModal.setAttribute('aria-hidden', 'false');
          this.DOM.pickupModal.removeAttribute('inert');
          document.body.style.overflow = 'hidden';

          document.addEventListener('keyup', this.handlePickupModalKeyUp);
          document.addEventListener('keydown', this.handlePickupModalKeyDown);
          document.addEventListener('focusin', this.handlePickupModalFocusIn);

          this.pickupModalIsOpen = true;

          setTimeout(() => {
            const focusableElements = this.getPickupModalFocusableElements();
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }, 100);
        }
      };

      this.closePickupModal = () => {
        if (this.DOM.pickupModal && this.pickupModalIsOpen) {
          this.DOM.pickupModal.classList.remove('is-active');
          this.DOM.pickupModal.setAttribute('aria-hidden', 'true');
          this.DOM.pickupModal.setAttribute('inert', '');
          document.body.style.overflow = '';

          document.removeEventListener('keyup', this.handlePickupModalKeyUp);
          document.removeEventListener('keydown', this.handlePickupModalKeyDown);
          document.removeEventListener('focusin', this.handlePickupModalFocusIn);

          this.pickupModalIsOpen = false;

          if (this.pickupTriggerElement) {
            this.pickupTriggerElement.focus();
          }
        }
      };

      this.handlePickupModalKeyUp = (event) => {
        if (event.key === 'Escape') {
          this.closePickupModal();
        }
      };

      this.handlePickupModalKeyDown = (event) => {
        if (event.key === 'Tab' && this.pickupModalIsOpen) {
          this.trapPickupModalFocus(event);
        }
      };

      this.handlePickupModalFocusIn = (event) => {
        if (this.pickupModalIsOpen && this.pickupModalContent && !this.pickupModalContent.contains(event.target)) {
          event.preventDefault();
          const focusableElements = this.getPickupModalFocusableElements();
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          }
        }
      };

      this.onRecipientCheckboxChange = () => {
        if (!this.recipientCheckbox) return;

        if (this.recipientCheckbox.checked) {
          this.enableRecipientInputFields();
          if (this.recipientFieldsLiveRegion && window.accessibilityStrings) {
            this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          }
        } else {
          this.clearRecipientInputFields();
          this.disableRecipientInputFields();
          if (this.recipientFieldsLiveRegion && window.accessibilityStrings) {
            this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
          }
        }
      };

      this.onOptionValueChange = (payload) => {
        const data = payload.data;
        const option = data.target;

        if (this.updateUrl === 'false') {
          const variantUrl = option.dataset.url || option.dataset.productUrl || this.url;
          this.fetchFeaturedProduct(variantUrl);
          return;
        }

        const selectedOptionValues = [];
        for (let i = 0; i < this.variantSelects.length; i++) {
          selectedOptionValues.push(this.variantSelects[i].getSelectedValue().id);
        }

        const productUrl = data.target.dataset.productUrl || this.pendingRequestUrl || this.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.url !== productUrl;
        const shouldFetchFullPage = this.updateUrl === 'true' && shouldSwapProduct;
        const requestUrl = this.buildRequestUrl(productUrl, selectedOptionValues, shouldFetchFullPage);

        this.getProductInfos({
          requestUrl: requestUrl,
          callback: (html) => {
            this.swapProduct(productUrl, html);
          },
        });
      };

      this.onVariantChange = (payload) => {
        const data = payload.data;
        const selectedOption = data.target.querySelector('.js-sticky-variant-option.is-selected');

        const variantUrl = selectedOption.dataset.url;
        const productUrl = variantUrl.split('?')[0] || this.pendingRequestUrl || this.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.url !== productUrl;
        const shouldFetchFullPage = this.updateUrl === 'true' && shouldSwapProduct;

        this.getProductInfos({
          requestUrl: variantUrl,
          callback: (html) => {
            this.swapProduct(productUrl, html);
          },
        });
      };

      this.onButtonOptionChange = (event) => {
        const target = event.currentTarget;

        if (this.updateUrl === 'false') {
          const variantUrl = target.dataset.url || target.dataset.productUrl || this.url;
          this.fetchFeaturedProduct(variantUrl);
          return;
        }

        const selectedOptionValues = [];

        for (let i = 0; i < this.DOM.buttonsOptionsWraps.length; i++) {
          const optionsWrap = this.DOM.buttonsOptionsWraps[i];
          const buttonOptions = optionsWrap.querySelectorAll('.js-variant-button-option');
          for (let j = 0; j < buttonOptions.length; j++) {
            const buttonOption = buttonOptions[j];
            if (buttonOption.checked) {
              selectedOptionValues.push(buttonOption.dataset.optionValueId);
            }
          }
        }

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.url;
        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = this.url !== productUrl;
        const shouldFetchFullPage = this.updateUrl === 'true' && shouldSwapProduct;
        const requestUrl = this.buildRequestUrl(productUrl, selectedOptionValues, shouldFetchFullPage);

        this.getProductInfos({
          requestUrl: requestUrl,
          callback: (html) => {
            this.swapProduct(productUrl, html);
          },
        });
      };

      this.onQuantityUpdate = (payload) => {
        const data = payload.data;
        this.quantity = data.quantity;

        if (this.quantity !== this.quantityInput.getQuantity()) {
          this.quantityInput.DOM.input.value = data.quantity;
        }
      };

      this.buildRequestUrl = (url, optionValues, shouldFetchFullPage = false) => {
        const params = [];

        if (!shouldFetchFullPage) params.push('section_id=' + this.sectionId);
        if (optionValues.length) {
          params.push('option_values=' + optionValues.join(','));
        }

        return url + '?' + params.join('&');
      };

      this.getProductInfos = (opts) => {
        const requestUrl = opts.requestUrl;
        const callback = opts.callback;

        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      };

      this.fetchFeaturedProduct = (variantUrl) => {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        const wrapper = this.DOM.wrap.querySelector('.js-featured-product-wrapper');
        if (!wrapper) {
          console.error('Featured product wrapper not found');
          return;
        }

        const productUrl = variantUrl.split('?')[0];
        const variantParam = variantUrl.indexOf('?') !== -1 ? variantUrl.split('?')[1] : '';

        const params = ['sections=' + this.sectionId];
        if (variantParam) {
          params.push(variantParam);
        }

        const requestUrl = productUrl + '?' + params.join('&');

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.json())
          .then((sections) => {
            const sectionHtml = sections[this.sectionId];
            if (!sectionHtml) {
              console.error('Section HTML not found in response');
              return;
            }

            const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const newContent = html.querySelector('.js-featured-product-content');

            if (newContent) {
              const contentContainer = wrapper.querySelector('.js-featured-product-content');

              if (contentContainer) {
                this.partialDestroy();

                contentContainer.textContent = '';
                newContent.querySelectorAll('[data-scroll]').forEach((el) => el.classList.add('is-visible'));
                while (newContent.firstChild) {
                  contentContainer.appendChild(newContent.firstChild);
                }

                this.DOM.productMediaCarousel = this.DOM.wrap.querySelector('.js-product-media-carousel-section');
                this.DOM.productPairsCarousel = this.DOM.wrap.querySelector('.js-product-pairs-carousel-section');
                this.DOM.productReviewsCarousel = this.DOM.wrap.querySelector('.js-product-reviews-carousel-section');
                this.DOM.productMediaBlockCarousel = this.DOM.wrap.querySelector('.js-product-media-block-carousel-section');
                this.DOM.selects = this.DOM.wrap.querySelectorAll('.js-variant-select');
                this.DOM.buttonsOptionsWraps = this.DOM.wrap.querySelectorAll('.js-variant-buttons-wrap');
                this.DOM.buttonOptions = this.DOM.wrap.querySelectorAll('.js-variant-button-option');
                this.DOM.sharers = this.DOM.wrap.querySelectorAll('.js-share-url');
                this.DOM.quantityInput = this.DOM.wrap.querySelector('.js-single-product-item-quantity');
                this.DOM.countdown = this.DOM.wrap.querySelector('.js-single-product-countdown');
                this.DOM.sizeChartOpeners = this.DOM.wrap.querySelectorAll('.js-single-product-size-open');
                this.DOM.sizeChartModal = this.DOM.wrap.querySelector('.js-single-product-size-modal');
                this.DOM.delivery = this.DOM.wrap.querySelector('.js-single-product-delivery');
                this.DOM.stickyAddtoCart = this.DOM.wrap.querySelector('.js-product-sticky-form');
                this.DOM.pickupModal = this.DOM.wrap.querySelector('.js-pickup-availability-modal');

                this.productCountdown = undefined;
                this.productMediaCarousel = undefined;
                this.productPairsCarousel = undefined;
                this.productReviewsCarousel = undefined;
                this.productMediaBlockCarousel = undefined;
                this.sizeChart = undefined;
                this.quantityInput = undefined;
                this.variantSelects = [];
                this.sharers = [];
                this.stickyAddtoCart = undefined;

                iman.add('productForms', new ProductForms());
                if (window.Shopify && window.Shopify.PaymentButton) {
                  window.Shopify.PaymentButton.init();
                }

                this.setup();
                iman.get('scrollAnimator')?.init(contentContainer);
                iman.get('lightbox')?.destroy();
                iman.add('lightbox', new Lightbox());
              }
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Featured product fetch aborted');
            } else {
              console.error('Error fetching featured product:', error);
            }
          });
      };

      this.swapProduct = (productUrl, html) => {
        const newVariantHtml = html.querySelector('[data-selected-variant]').innerHTML;

        let newVariant;
        let newVariantId;
        if (newVariantHtml) {
          newVariant = JSON.parse(newVariantHtml);
          if (this.stickyAddtoCart) {
            this.stickyAddtoCart.updateInstance(newVariant);
          }
        }
        if (newVariant) {
          newVariantId = newVariant.id;
        }
        const newSingleProduct = html.querySelector('.js-single-product');

        const newProductHtml = newSingleProduct.innerHTML;

        this.swapDestroy();

        this.DOM.wrap.textContent = '';
        const tempDiv = document.createElement('div');
        /* NOTE: innerHTML used intentionally for same-origin Shopify section content */
        tempDiv.innerHTML = newProductHtml;
        tempDiv.querySelectorAll('[data-scroll]').forEach((el) => el.classList.add('is-visible'));
        while (tempDiv.firstChild) {
          this.DOM.wrap.appendChild(tempDiv.firstChild);
        }
        this.DOM.wrap.dataset.updateUrl = newSingleProduct.dataset.updateUrl;
        this.DOM.wrap.dataset.section = newSingleProduct.dataset.section;
        this.DOM.wrap.dataset.url = newSingleProduct.dataset.url;
        this.DOM.wrap.dataset.productId = newSingleProduct.dataset.productId;

        this.DOM.productMediaCarousel = this.DOM.wrap.querySelector('.js-product-media-carousel-section');
        this.DOM.productPairsCarousel = this.DOM.wrap.querySelector('.js-product-pairs-carousel-section');
        this.DOM.productReviewsCarousel = this.DOM.wrap.querySelector('.js-product-reviews-carousel-section');
        this.DOM.productMediaBlockCarousel = this.DOM.wrap.querySelector('.js-product-media-block-carousel-section');
        this.DOM.selects = this.DOM.wrap.querySelectorAll('.js-variant-select');
        this.DOM.buttonsOptionsWraps = this.DOM.wrap.querySelectorAll('.js-variant-buttons-wrap');
        this.DOM.buttonOptions = this.DOM.wrap.querySelectorAll('.js-variant-button-option');
        this.DOM.sharers = this.DOM.wrap.querySelectorAll('.js-share-url');
        this.DOM.quantityInput = this.DOM.wrap.querySelector('.js-single-product-item-quantity');
        this.DOM.countdown = this.DOM.wrap.querySelector('.js-single-product-countdown');
        this.DOM.sizeChartOpeners = this.DOM.wrap.querySelectorAll('.js-single-product-size-open');
        this.DOM.sizeChartModal = this.DOM.wrap.querySelector('.js-single-product-size-modal');
        this.DOM.delivery = this.DOM.wrap.querySelector('.js-single-product-delivery');
        this.DOM.stickyAddtoCart = this.DOM.wrap.querySelector('.js-product-sticky-form');
        this.DOM.recipientForm = this.DOM.wrap.querySelector('.js-recipient-form');
        this.DOM.accordions = this.DOM.wrap.querySelectorAll('.js-products-accordion');
        this.DOM.pickupModal = this.DOM.wrap.querySelector('.js-pickup-availability-modal');

        this.productCountdown = undefined;
        this.productMediaCarousel = undefined;
        this.productPairsCarousel = undefined;
        this.productReviewsCarousel = undefined;
        this.productMediaBlockCarousel = undefined;
        this.sizeChart = undefined;
        this.quantityInput = undefined;
        this.variantSelects = [];
        this.abortController = undefined;
        this.sectionId = this.DOM.wrap.dataset.section;
        this.url = this.DOM.wrap.dataset.url;
        this.pendingRequestUrl = undefined;
        this.stickyAddtoCart = undefined;
        this.updateUrl = this.DOM.wrap.dataset.updateUrl;

        if (this.updateUrl === 'true') {
          this.updateURL(productUrl, newVariantId);
        }

        iman.add('productForms', new ProductForms());

        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        this.setup();
        iman.get('scrollAnimator')?.init(this.DOM.wrap);
        iman.get('lightbox')?.destroy();
        iman.add('lightbox', new Lightbox());
        this.announceVariantStatus(newVariant);
      };

      this.announceVariantStatus = (variant) => {
        if (!variant || !window.accessibilityStrings) return;
        const wrap = this.DOM.wrap.parentElement;
        if (!wrap) return;
        const statusEl = wrap.querySelector('[data-variant-status]');
        if (!statusEl) return;

        const variantTitle = variant.title || '';
        let priceText = '';
        if (typeof variant.price === 'number') {
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            priceText = window.Shopify.formatMoney(variant.price);
          } else {
            priceText = (variant.price / 100).toFixed(2);
          }
        }

        let template;
        if (variant.available === false) {
          template = window.accessibilityStrings.variantStatusSoldOut;
        } else if (variant.available === true) {
          template = window.accessibilityStrings.variantStatusAvailable;
        } else {
          template = window.accessibilityStrings.variantStatusUnavailable;
        }
        if (!template) return;

        const message = template
          .replace('[variant]', variantTitle)
          .replace('[price]', priceText);

        statusEl.textContent = message;
      };

      this.swapDestroy = () => {
        this.partialDestroy();
      };

      this.init(mainContainer);
    }

    setup() {
      let i;

      for (i = 0; i < this.DOM.sharers.length; i++) {
        this.sharers.push(new Sharer(this.DOM.sharers[i]));
      }

      if (this.DOM.quantityInput) {
        this.quantityInput = new QuantityInput(this.DOM.quantityInput);
        this.quantity = this.quantityInput.getQuantity();
        this.quantityUpdateUnsubscriber = subEvents.subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityUpdate);
      }

      if (this.DOM.countdown) {
        this.productCountdown = new ProductCountdown(this.DOM.countdown);
      }

      if (this.DOM.sizeChartOpeners.length) {
        this.sizeChart = new SizeChart(this.DOM.sizeChartOpeners, this.DOM.sizeChartModal);
      }

      if (this.DOM.productMediaCarousel) {
        let options;
        if (this.isSecondary) {
          options = {
            watchDrag: true,
            breakpoints: {
              '(min-width: 1024px)': {
                align: 'start',
                containScroll: false,
              },
              '(max-width: 1023px)': {
                containScroll: 'trimSnaps',
              },
            },
          };
        }
        this.productMediaCarousel = new ProductMediaCarousel(this.DOM.productMediaCarousel, options);
      }

      if (this.DOM.productReviewsCarousel) {
        this.productReviewsCarousel = new ProductReviewsCarousel(this.DOM.productReviewsCarousel);
      }

      if (this.DOM.productMediaBlockCarousel) {
        // The media_carousel block reuses the generic reviews-carousel controller
        // (BaseCarousel + autoplay + prev/next nav).
        this.productMediaBlockCarousel = new ProductReviewsCarousel(this.DOM.productMediaBlockCarousel);
      }

      if (this.DOM.productPairsCarousel) {
        this.productPairsCarousel = new ProductPairsCarousel(this.DOM.productPairsCarousel);
      }

      for (i = 0; i < this.DOM.selects.length; i++) {
        this.variantSelects.push(new VariantSelect(this.DOM.selects[i]));
      }

      for (i = 0; i < this.DOM.buttonOptions.length; i++) {
        this.DOM.buttonOptions[i].addEventListener('change', this.onButtonOptionChange);
      }

      if (this.DOM.delivery) {
        this.setupDelivery();
      }

      if (this.DOM.pickupModal) {
        this.setupPickupAvailability();
      }

      if (this.DOM.recipientForm) {
        this.setupRecipientForm();
      }

      this.variantUpdateUnsubscriber = subEvents.subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.onOptionValueChange,
      );

      if (this.DOM.stickyAddtoCart) {
        this.stickyAddtoCart = new StickyAddtoCart();
      }

      this.accordions = [];
      if (this.DOM.accordions) {
        const accordions = this.DOM.accordions;
        for (i = 0; i < accordions.length; i++) {
          this.accordions.push(new Accordion(accordions[i]));
        }
      }

      this.stickyVariantUnsubscriber = subEvents.subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);

      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    }

    setupDelivery() {
      const orderEl = this.DOM.delivery.querySelector('.js-order');
      const purchaseEl = this.DOM.delivery.querySelector('.js-purchase');
      const shippingEl = this.DOM.delivery.querySelector('.js-shipping');

      const delayPurchase = parseInt(this.DOM.delivery.dataset.delayPurchase);
      const purchaseTolerance = parseInt(this.DOM.delivery.dataset.purchaseTolerance);
      const delayShipping = parseInt(this.DOM.delivery.dataset.delayShipping);
      const shippingTolerance = parseInt(this.DOM.delivery.dataset.shippingTolerance);
      const dateFormat = this.DOM.delivery.dataset.dateFormat;
      const shipOnSaturday = this.DOM.delivery.dataset.shipOnSaturday === 'true';
      const shipOnSunday = this.DOM.delivery.dataset.shipOnSunday === 'true';
      const deliverOnSaturday = this.DOM.delivery.dataset.deliverOnSaturday === 'true';
      const deliverOnSunday = this.DOM.delivery.dataset.deliverOnSunday === 'true';
      const cutoffHourRaw = this.DOM.delivery.dataset.cutoffHour;
      const cutoffMinuteRaw = this.DOM.delivery.dataset.cutoffMinute;
      const holidays = this.parseHolidays(this.DOM.delivery.dataset.holidays);

      const now = new Date();
      orderEl.textContent = this.formatDeliveryDate(now, dateFormat);

      let startDate = new Date(now);
      if (cutoffHourRaw !== '') {
        const cutoffHour = parseInt(cutoffHourRaw);
        const cutoffMinute = cutoffMinuteRaw !== '' ? parseInt(cutoffMinuteRaw) : 0;
        if (now.getHours() * 60 + now.getMinutes() >= cutoffHour * 60 + cutoffMinute) {
          startDate = this.addWorkingDays(now, 1, shipOnSaturday, shipOnSunday, holidays);
        }
      }

      const purchaseDate = delayPurchase > 0
        ? this.addWorkingDays(startDate, delayPurchase, shipOnSaturday, shipOnSunday, holidays)
        : new Date(startDate);

      let purchaseWindowEnd = purchaseDate;
      if (purchaseTolerance > 0) {
        const purchaseToleranceDate = this.addWorkingDays(purchaseDate, purchaseTolerance, shipOnSaturday, shipOnSunday, holidays);
        purchaseEl.textContent =
          this.formatDeliveryDate(purchaseDate, dateFormat) +
          ' - ' +
          this.formatDeliveryDate(purchaseToleranceDate, dateFormat);
        purchaseWindowEnd = purchaseToleranceDate;
      } else {
        purchaseEl.textContent = this.formatDeliveryDate(purchaseDate, dateFormat);
      }

      const shippingDate = delayShipping > 0
        ? this.addWorkingDays(purchaseWindowEnd, delayShipping, deliverOnSaturday, deliverOnSunday, holidays)
        : new Date(purchaseWindowEnd);

      if (shippingTolerance > 0) {
        const shippingToleranceDate = this.addWorkingDays(shippingDate, shippingTolerance, deliverOnSaturday, deliverOnSunday, holidays);
        shippingEl.textContent =
          this.formatDeliveryDate(shippingDate, dateFormat) +
          ' - ' +
          this.formatDeliveryDate(shippingToleranceDate, dateFormat);
      } else {
        shippingEl.textContent = this.formatDeliveryDate(shippingDate, dateFormat);
      }
    }

    parseHolidays(str) {
      if (!str) return [];
      const monthMap = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
      return str.split(',').reduce((acc, entry) => {
        const match = entry.trim().toLowerCase().match(/^(\d+)([a-z]+)$/);
        if (match) {
          const day = parseInt(match[1]);
          const month = monthMap[match[2]];
          if (month !== undefined) acc.push({ day, month });
        }
        return acc;
      }, []);
    }

    addWorkingDays(date, days, shipOnSaturday, shipOnSunday, holidays) {
      const result = new Date(date);
      let remaining = days;
      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        const dow = result.getDay();
        if (dow === 6 && !shipOnSaturday) continue;
        if (dow === 0 && !shipOnSunday) continue;
        if (holidays && holidays.some((h) => h.day === result.getDate() && h.month === result.getMonth())) continue;
        remaining--;
      }
      return result;
    }

    formatDeliveryDate(date, format) {
      let dd, mm, yyyy;
      switch (format) {
        case 'day_number_month_name':
          return date.toLocaleDateString(navigator.language || 'default', {
            day: 'numeric',
            month: 'short',
          });
        case 'dd_mm':
          dd = String(date.getDate()).padStart(2, '0');
          mm = String(date.getMonth() + 1).padStart(2, '0');
          return dd + '/' + mm;
        case 'mm_dd':
          mm = String(date.getMonth() + 1).padStart(2, '0');
          dd = String(date.getDate()).padStart(2, '0');
          return mm + '/' + dd;
        default:
          dd = String(date.getDate()).padStart(2, '0');
          mm = String(date.getMonth() + 1).padStart(2, '0');
          yyyy = date.getFullYear();
          return dd + '/' + mm + '/' + yyyy;
      }
    }

    setupPickupAvailability() {
      this.pickupTrigger = this.DOM.pickupModal.parentElement.querySelector('.js-pickup-availability-trigger');
      this.pickupModalCloseButtons = this.DOM.pickupModal.querySelectorAll('.js-pickup-modal-close');
      this.pickupModalContent = this.DOM.pickupModal.querySelector('.single-product__pickup-modal-content');
      this.pickupModalIsOpen = false;

      if (this.pickupTrigger) {
        this.pickupTrigger.addEventListener('click', this.openPickupModal);
      }

      this.pickupModalCloseButtons.forEach((button) => {
        button.addEventListener('click', this.closePickupModal);
      });

      this.DOM.pickupModal.setAttribute('aria-hidden', 'true');
      this.DOM.pickupModal.setAttribute('inert', '');
    }

    getPickupModalFocusableElements() {
      if (!this.pickupModalContent) return [];

      const selector =
        'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const elements = Array.from(this.pickupModalContent.querySelectorAll(selector));

      return elements.filter((el) => {
        if (el.getAttribute('aria-hidden') === 'true') return false;
        if (el.closest('[aria-hidden="true"]')) return false;

        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return false;

        return true;
      });
    }

    trapPickupModalFocus(event) {
      const focusableElements = this.getPickupModalFocusableElements();

      if (focusableElements.length === 0) return;

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (event.shiftKey) {
        if (activeElement === firstFocusable || !this.pickupModalContent.contains(activeElement)) {
          event.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (activeElement === lastFocusable || !this.pickupModalContent.contains(activeElement)) {
          event.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    setupRecipientForm() {
      const sectionId = this.DOM.recipientForm.dataset.sectionId;
      this.currentProductVariantId = this.DOM.recipientForm.dataset.productVariantId;

      this.recipientFieldsLiveRegion = this.DOM.recipientForm.querySelector('.js-recipient-live-region');
      this.recipientCheckbox = this.DOM.recipientForm.querySelector('.js-recipient-checkbox');
      this.recipientControlField = this.DOM.recipientForm.querySelector('.js-recipient-control');
      this.recipientEmail = this.DOM.recipientForm.querySelector('.js-recipient-email');
      this.recipientName = this.DOM.recipientForm.querySelector('.js-recipient-name');
      this.recipientMessage = this.DOM.recipientForm.querySelector('.js-recipient-message');
      this.recipientSendon = this.DOM.recipientForm.querySelector('.js-recipient-sendon');
      this.recipientOffset = this.DOM.recipientForm.querySelector('.js-recipient-offset');

      if (this.recipientCheckbox) {
        this.recipientCheckbox.addEventListener('change', this.onRecipientCheckboxChange);
      }

      if (this.recipientControlField) {
        this.recipientControlField.disabled = true;
      }

      if (this.recipientOffset) {
        this.recipientOffset.value = new Date().getTimezoneOffset().toString();
      }

      this.recipientCartUpdateUnsubscriber = subEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
          this.resetRecipientForm();
        }
      });

      this.recipientVariantChangeUnsubscriber = subEvents.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId === sectionId) {
          this.currentProductVariantId = event.data.variant.id.toString();
        }
      });

      this.onRecipientCheckboxChange();
    }

    getRecipientInputFields() {
      return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendon].filter(
        (field) => field,
      );
    }

    getRecipientDisableableFields() {
      const fields = this.getRecipientInputFields();
      if (this.recipientOffset) fields.push(this.recipientOffset);
      return fields.filter((field) => field);
    }

    clearRecipientInputFields() {
      this.getRecipientInputFields().forEach((field) => {
        field.value = '';
      });
    }

    enableRecipientInputFields() {
      this.getRecipientDisableableFields().forEach((field) => {
        field.disabled = false;
      });
    }

    disableRecipientInputFields() {
      this.getRecipientDisableableFields().forEach((field) => {
        field.disabled = true;
      });
    }

    resetRecipientForm() {
      if (this.recipientCheckbox && this.recipientCheckbox.checked) {
        this.recipientCheckbox.checked = false;
        this.clearRecipientInputFields();
      }
    }

    updateURL(url, variantId) {
      window.history.replaceState({}, '', url + (variantId ? '?variant=' + variantId : ''));
    }

    reinit() {
      this.destroy();
      this.init();
    }

    partialDestroy() {
      let i;

      for (i = 0; i < this.sharers.length; i++) {
        this.sharers[i].destroy();
      }
      this.sharers = [];

      if (this.productMediaCarousel) {
        this.productMediaCarousel.destroy();
        this.productMediaCarousel = undefined;
      }

      if (this.productCountdown) {
        this.productCountdown.destroy();
        this.productCountdown = undefined;
      }

      if (this.sizeChart) {
        this.sizeChart.destroy();
        this.sizeChart = undefined;
      }

      if (this.productReviewsCarousel) {
        this.productReviewsCarousel.destroy();
        this.productReviewsCarousel = undefined;
      }

      if (this.productMediaBlockCarousel) {
        this.productMediaBlockCarousel.destroy();
        this.productMediaBlockCarousel = undefined;
      }

      if (this.productPairsCarousel) {
        this.productPairsCarousel.destroy();
        this.productPairsCarousel = undefined;
      }

      if (this.quantityInput) {
        this.quantityInput.destroy();
        this.quantityInput = undefined;
      }

      if (this.stickyAddtoCart) {
        this.stickyAddtoCart.destroy();
        this.stickyAddtoCart = undefined;
      }

      if (this.pickupTrigger) {
        this.pickupTrigger.removeEventListener('click', this.openPickupModal);
        this.pickupTrigger = undefined;
      }

      if (this.pickupModalCloseButtons) {
        this.pickupModalCloseButtons.forEach((button) => {
          button.removeEventListener('click', this.closePickupModal);
        });
        this.pickupModalCloseButtons = undefined;
      }

      document.removeEventListener('keyup', this.handlePickupModalKeyUp);
      document.removeEventListener('keydown', this.handlePickupModalKeyDown);
      document.removeEventListener('focusin', this.handlePickupModalFocusIn);

      if (this.pickupModalIsOpen && this.DOM.pickupModal) {
        document.body.style.overflow = '';
        this.DOM.pickupModal.setAttribute('aria-hidden', 'true');
        this.DOM.pickupModal.setAttribute('inert', '');
      }

      this.pickupModalContent = undefined;
      this.pickupModalIsOpen = false;
      this.pickupTriggerElement = undefined;

      if (this.recipientCheckbox) {
        this.recipientCheckbox.removeEventListener('change', this.onRecipientCheckboxChange);
        this.recipientCheckbox = undefined;
      }

      if (this.recipientCartUpdateUnsubscriber) {
        this.recipientCartUpdateUnsubscriber();
        this.recipientCartUpdateUnsubscriber = undefined;
      }

      if (this.recipientVariantChangeUnsubscriber) {
        this.recipientVariantChangeUnsubscriber();
        this.recipientVariantChangeUnsubscriber = undefined;
      }

      for (i = 0; i < this.variantSelects.length; i++) {
        this.variantSelects[i].destroy();
      }
      this.variantSelects = [];

      for (i = 0; i < this.DOM.buttonOptions.length; i++) {
        this.DOM.buttonOptions[i].removeEventListener('change', this.onButtonOptionChange);
      }

      const productForms = iman.get('productForms');
      if (productForms) {
        productForms.destroy();
        iman.remove('productForms');
      }
    }

    destroy() {
      if (this.DOM) {
        this.partialDestroy();

        if (this.variantUpdateUnsubscriber) {
          this.variantUpdateUnsubscriber();
          this.variantUpdateUnsubscriber = undefined;
        }

        if (this.stickyVariantUnsubscriber) {
          this.stickyVariantUnsubscriber();
          this.stickyVariantUnsubscriber = undefined;
        }

        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
          this.quantityUpdateUnsubscriber = undefined;
        }

        this.DOM = undefined;
      }
    }

    init(mainContainer) {
      if (mainContainer) {
        const wrap = mainContainer.querySelector('.js-single-product');

        if (wrap) {
          this.DOM = {};
          this.DOM.wrap = wrap;
          this.DOM.productMediaCarousel = this.DOM.wrap.querySelector('.js-product-media-carousel-section');
          this.DOM.productReviewsCarousel = this.DOM.wrap.querySelector('.js-product-reviews-carousel-section');
          this.DOM.productMediaBlockCarousel = this.DOM.wrap.querySelector('.js-product-media-block-carousel-section');
          this.DOM.productPairsCarousel = this.DOM.wrap.querySelector('.js-product-pairs-carousel-section');
          this.DOM.selects = wrap.querySelectorAll('.js-variant-select');
          this.DOM.buttonsOptionsWraps = wrap.querySelectorAll('.js-variant-buttons-wrap');
          this.DOM.buttonOptions = wrap.querySelectorAll('.js-variant-button-option');
          this.DOM.sharers = wrap.querySelectorAll('.js-share-url');
          this.DOM.quantityInput = wrap.querySelector('.js-single-product-item-quantity');
          this.DOM.countdown = wrap.querySelector('.js-single-product-countdown');
          this.DOM.sizeChartOpeners = wrap.querySelectorAll('.js-single-product-size-open');
          this.DOM.sizeChartModal = wrap.querySelector('.js-single-product-size-modal');
          this.DOM.delivery = wrap.querySelector('.js-single-product-delivery');
          this.DOM.stickyAddtoCart = wrap.querySelector('.js-product-sticky-form');
          this.DOM.recipientForm = wrap.querySelector('.js-recipient-form');
          this.DOM.accordions = this.DOM.wrap.querySelectorAll('.js-products-accordion');
          this.DOM.pickupModal = wrap.querySelector('.js-pickup-availability-modal');

          this.isSecondary = wrap.classList.contains('js-secondary-single-product');
          this.productCountdown = undefined;
          this.productMediaCarousel = undefined;
          this.productPairsCarousel = undefined;
          this.productReviewsCarousel = undefined;
          this.productMediaBlockCarousel = undefined;
          this.sizeChart = undefined;
          this.quantityInput = undefined;
          this.variantSelects = [];
          this.sharers = [];
          this.abortController = undefined;
          this.sectionId = wrap.dataset.section;
          this.url = wrap.dataset.url;
          this.pendingRequestUrl = undefined;
          this.updateUrl = wrap.dataset.updateUrl;
          this.stickyAddtoCart = undefined;

          this.setup();
        }
      }
    }
  }

  window.Universe.SingleProduct = SingleProduct;
})();
